import { Layout as AntLayout, Input } from 'antd';
import { navigate } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import Footer from './Footer';
import Header from './Header';
import { Media } from './Media';
import AdviceFeaturedPostsContainer from '../containers/AdviceFeaturedPostsContainer';
import BlogFeaturedPostsContainer from '../containers/BlogFeaturedPostsContainer';
import CategoryListContainer from '../containers/CategoryListContainer';
import TagsSelector from '../containers/TagsListContainer';

const { Header: AntHeader, Footer: AntFooter, Content, Sider } = AntLayout;
const { Search } = Input;

const Section = styled.div`
  padding: 2rem 0;
`;

const ContentWrapper = styled.div`
  width: 100%;

  @media (min-width: 768px) {
    padding: 0 1rem;
  }

  @media (min-width: 1024px) {
    margin: 2rem auto 4rem auto;
    padding: 0 2rem;
  }

  @media (min-width: 1280px) {
    max-width: 1280px;
    padding: 0;
  }
`;

const MobileContentWrapper = styled.div`
  padding: 0 2rem;
`;

const TextHeading: React.FC = ({ children }) => (
  <h2 className='heading'>{children}</h2>
);

const FeaturedPosts: React.FC = () => {
  const blogType = process.env.GATSBY_BLOG_TYPE;
  return (
    <React.Fragment>
      {blogType === 'blog' ? (
        <BlogFeaturedPostsContainer />
      ) : (
        <AdviceFeaturedPostsContainer />
      )}
    </React.Fragment>
  );
};

const Layout: React.FC = ({ children }) => {
  const handleSearch = (input: string) => {
    if (input) {
      navigate(`/search?query=${input}`);
    }
  };

  return (
    <AntLayout>
      <AntHeader style={{ padding: '0' }}>
        <Header style={{ maxWidth: '1280px', margin: '0 auto' }} />
      </AntHeader>
      <Media greaterThanOrEqual='lg'>
        <ContentWrapper>
          {/*
            Add the antd-layout-has-sider class manually to prevent flicker when loading the layout.

            The flicker is caused by the Layout component initial render without the Sider and then checking its children for its presence.
            After detection, only then will it add this class to render the sider's position correctly.
          */}
          <AntLayout className='ant-layout-has-sider'>
            <Content style={{ overflow: 'visible' }}>{children}</Content>
            <Sider width='30%' style={{ marginLeft: '4rem' }}>
              <Section>
                <Search onSearch={handleSearch} />
              </Section>
              <Section>
                <TextHeading>Categories</TextHeading>
                <CategoryListContainer />
              </Section>
              <Section>
                <TextHeading>Featured Posts</TextHeading>
                <FeaturedPosts />
              </Section>
              <Section>
                <TextHeading>Tags</TextHeading>
                <TagsSelector />
              </Section>
            </Sider>
          </AntLayout>
        </ContentWrapper>
      </Media>

      <Media lessThan='lg'>
        <MobileContentWrapper>
          {/* TODO: Create mobile layout components handle spacing */}
          <Section style={{ paddingBottom: '0' }}>
            <Search onSearch={handleSearch} />
          </Section>

          <Section style={{ paddingTop: '0' }}>{children}</Section>
        </MobileContentWrapper>

        <MobileContentWrapper className='background-light'>
          <Section style={{ paddingBottom: '0' }}>
            <TextHeading>Categories</TextHeading>
            <CategoryListContainer />
          </Section>
          <Section style={{ paddingBottom: '0' }}>
            <TextHeading>Featured Posts</TextHeading>
            <FeaturedPosts />
          </Section>
          <Section>
            <TextHeading>Tags</TextHeading>
            <TagsSelector />
          </Section>
        </MobileContentWrapper>
      </Media>

      <AntFooter>
        <ContentWrapper>
          <Footer />
        </ContentWrapper>
      </AntFooter>
    </AntLayout>
  );
};

export default Layout;
